import BackgroundRush from "../components/headers/RushHeader";
import "../components/headers/Headers.css";
import Stack from '@mui/system/Stack';
import Container from '@mui/material/Container';
import RushGallery from '../components/RushGallery';

import side1 from "../media/Rush/1.png";
import side2 from "../media/Rush/2.png";

export default function Rush() {
  return (
    <>
    <div className="Headers">
        <BackgroundRush />
    </div>
    <br></br>
    <br></br>
    <Container justifyContent="center" maxWidth='md'>
    <Stack spacing={2}>
      <img src={side1} alt='side1'></img>
      <img src={side2} alt='side2'></img>
      <br></br>
      <RushGallery />
    </Stack>
    </Container>
    <br></br>
    <br></br>
    </>
  )
}